<template>
  <v-list>
    <template v-for="(style, index) of computedStyles">
      <v-list-item class="px-0" :key="style.key" style="max-height: 30px; min-height: 0px">
        <v-list-item-action class="mx-0 my-0 mr-1">
          <img v-if="style.icon" width="20px" height="20px" :src="style.icon" class="mr-1" />
          <legend-layer-list-icon v-else :color="style.color" :layer-type="layerType"></legend-layer-list-icon>
        </v-list-item-action>
        <v-list-item-title style="text-align: left" class="text-body-2" :class="{ 'text--disabled': !hasPermission }">
          {{ style.key }}
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        :key="style.key + '-collapse'"
        class="px-0"
        style="max-height: 30px; min-height: 0px"
        v-if="isExpandedVisible && index === computedStyles.length - 1"
      >
        <v-list-item-action class="mx-0 my-0 mr-1">
          <link-underlined @click="isExpanded = !isExpanded" :translation-path="textPath"> </link-underlined>
        </v-list-item-action>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import LegendLayerListIcon from '@/components/LegendLayerListIcon';
import LinkUnderlined from '@/components/LinkUnderlined';

const MAX_STYLES = 5;

export default {
  name: 'LegendLayersListStyles',
  components: {
    LegendLayerListIcon,
    LinkUnderlined,
  },
  props: {
    defaultStyle: {
      type: Object,
    },
    styles: {
      type: Array,
      required: true,
    },
    layerType: {
      type: String,
      required: true,
    },
    hasPermission: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isExpanded: false,
  }),
  computed: {
    computedStyles() {
      const defaultStyle = JSON.parse(JSON.stringify(this.defaultStyle));
      defaultStyle.color = this.getIconColor(defaultStyle);
      defaultStyle.key = this.$i18n.t('default.others');
      defaultStyle.icon = defaultStyle.externalGraphic && this.getIcon(defaultStyle.externalGraphic);

      const styles = this.styles.concat([defaultStyle]);

      return this.isExpanded ? styles : styles.slice(0, MAX_STYLES);
    },
    isExpandedVisible() {
      return this.styles.length + 1 > MAX_STYLES;
    },
    textPath() {
      return this.isExpanded ? 'sidebar.showLess' : 'sidebar.showMore';
    },
  },
  methods: {
    getIcon(name) {
      return `${process.env.VUE_APP_API_URL}/icons/${name}`;
    },
    getIconColor(style) {
      if (style) {
        return style['fill-color'] || style['circle-color'] || style['line-color'] || 'green';
      } else {
        return 'grey';
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
